import { WebSocketMessageType } from '../enums/websocket-message-type';

export class WebSocketMessage {
    messageType: WebSocketMessageType;
    payload: any;

    public static fromJson(other: any): WebSocketMessage {
        const instance = new WebSocketMessage();
        instance.payload = other.Payload;
        instance.messageType = WebSocketMessageType[other.MessageType];
        return instance;
    }
}
